import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControlLabel,
  Checkbox,
  Button,
  useTheme,
} from "@mui/material";
import { createScreenFilter } from "../reducers/PerFilterReducer";
import { areAllPropsEmpty } from "../utils/functions";

const SaveFilterDialog = ({
  open,
  onClose,
  screenName,
  filters,
}) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const isEmpty = areAllPropsEmpty(filters);
  const [filterName, setFilterName] = useState("");
  const [availableOnlyToMe, setAvailableOnlyToMe] = useState(false);

  useEffect(() => {
    if (open) {
      setFilterName(null);
      setAvailableOnlyToMe(false)
    }
  }, [open]);

  const handleSaveFilter = () => {
    if (!filterName) return;
    dispatch(
      createScreenFilter(
        screenName,
        filterName,
        filters,
        availableOnlyToMe
      )
    );
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ fontSize: "20px" }}>Save Filter</DialogTitle>
      <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <TextField
          label="Save filter as"
          value={filterName}
          onChange={(e) => setFilterName(e.target.value)}
          fullWidth
          size="small"
          sx={{ mt: 2 }}
        />

        <FormControlLabel
          control={
            <Checkbox
              checked={availableOnlyToMe}
              onChange={(e) => setAvailableOnlyToMe(e.target.checked)}
            />
          }
          label="Available only to me"
        />
      </DialogContent>

      <DialogActions>
        <Button
          variant="contained"
          disabled={!filterName || isEmpty}
          onClick={handleSaveFilter}
        >
          Save
        </Button>
        <Button
          variant="outlined"
          onClick={onClose}
          sx={{
            color: theme.palette.mode === "dark" ? "#fff" : "primary",
            borderColor: theme.palette.mode === "dark" ? "#fff" : "primary",
            "&:hover": {
              borderColor: theme.palette.mode === "dark" ? "#fff" : "primary",
              backgroundColor: theme.palette.action.hover,
            },
          }}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SaveFilterDialog;
